/**
 * <komfid-calculator> — Komfid ROI beregner som Web Component
 * v1.1.0 — Shopify export
 *
 * Brug i Shopify Liquid:
 *   <script src="{{ 'komfid-calculator.js' | asset_url }}" defer></script>
 *   <komfid-calculator lang="da"></komfid-calculator>
 *
 * Attributter (alle valgfrie):
 *   lang            "da" | "en" | "de"            default: "en"
 *   currency        "DKK" | "EUR" | "USD" | "GBP" default: "DKK"
 *   default-guests  tal 50-2500                    default: 400
 *   package-url     checkout link                  default: komfid.com produkt
 *   package-price   pakke-pris i DKK               default: 1000
 *   package-size    låg per pakke                  default: 480
 *   lid-cost        pris per låg i DKK             default: 2.76
 *
 * Ingen deps. Shadow DOM = ingen style-konflikt med Shopify-temaet.
 */
(function () {
  if (customElements.get('komfid-calculator')) return;

  const CURRENCY = {
    DKK: { symbol: 'kr', rate: 1,    label: 'DKK - Dansk krone', locale: 'da-DK' },
    EUR: { symbol: '€',  rate: 0.13, label: 'EUR - Euro',        locale: 'de-DE' },
    USD: { symbol: '$',  rate: 0.14, label: 'USD - US Dollar',   locale: 'en-US' },
    GBP: { symbol: '£',  rate: 0.12, label: 'GBP - British Pound', locale: 'en-GB' },
  };

  const I18N = {
    da: {
      label: 'Beregner', headline: 'Din mulige', headlineAccent: 'indtjening',
      subheadline: 'Se hvad Komfid kan betyde for jeres virksomhed.',
      venueDetails: 'Venue detaljer', yourResults: 'Dine resultater',
      numberOfGuests: 'Antal gæster:', genderDistribution: 'Kønsfordeling:',
      male: 'Mænd', female: 'Kvinder', currency: 'Valuta', entranceFee: 'Entrépris',
      estimatedLids: 'Estimerede låg', perNight: 'per aften',
      costPerNight: 'Omkostning per aften', revenueIncrease: 'Potentiel omsætningsstigning',
      with2Percent: 'Med 2% flere gæster', with5Percent: 'Med 5% flere gæster',
      plusBarRevenue: 'Plus ekstra baromsætning fra øget gæstekøb',
      netBenefit: 'Nettofordel per aften', conservative: 'Konservativt (2%)',
      optimistic: 'Optimistisk (5%)', recommendedPackage: 'Anbefalet pakke',
      lids: 'låg', orderNow: 'Bestil nu', exclVat: 'Priser ekskl. moms',
      packageName: 'Komfid Pakke',
    },
    en: {
      label: 'Calculator', headline: 'Your potential', headlineAccent: 'revenue',
      subheadline: 'See what Komfid can mean for your business.',
      venueDetails: 'Venue Details', yourResults: 'Your Results',
      numberOfGuests: 'Number of Guests:', genderDistribution: 'Gender Distribution:',
      male: 'Male', female: 'Female', currency: 'Currency', entranceFee: 'Entrance Fee',
      estimatedLids: 'Estimated Lids Needed', perNight: 'per night',
      costPerNight: 'Cost Per Night', revenueIncrease: 'Revenue Increase Potential',
      with2Percent: 'With 2% more guests', with5Percent: 'With 5% more guests',
      plusBarRevenue: 'Plus additional bar revenue from increased guest purchases',
      netBenefit: 'Net Benefit Per Night', conservative: 'Conservative (2%)',
      optimistic: 'Optimistic (5%)', recommendedPackage: 'Recommended Package',
      lids: 'lids', orderNow: 'Order Now', exclVat: 'Prices excl. VAT',
      packageName: 'Komfid Package',
    },
    de: {
      label: 'Rechner', headline: 'Ihr potenzieller', headlineAccent: 'Umsatz',
      subheadline: 'Sehen Sie, was Komfid für Ihr Unternehmen bedeuten kann.',
      venueDetails: 'Venue-Details', yourResults: 'Ihre Ergebnisse',
      numberOfGuests: 'Anzahl der Gäste:', genderDistribution: 'Geschlechterverteilung:',
      male: 'Männer', female: 'Frauen', currency: 'Währung', entranceFee: 'Eintrittspreis',
      estimatedLids: 'Geschätzte benötigte Deckel', perNight: 'pro Abend',
      costPerNight: 'Kosten pro Abend', revenueIncrease: 'Potenzielle Umsatzsteigerung',
      with2Percent: 'Mit 2% mehr Gästen', with5Percent: 'Mit 5% mehr Gästen',
      plusBarRevenue: 'Plus zusätzlicher Barumsatz durch erhöhte Gästekäufe',
      netBenefit: 'Nettovorteil pro Abend', conservative: 'Konservativ (2%)',
      optimistic: 'Optimistisch (5%)', recommendedPackage: 'Empfohlenes Paket',
      lids: 'Deckel', orderNow: 'Jetzt bestellen', exclVat: 'Preise zzgl. MwSt.',
      packageName: 'Komfid Paket',
    },
  };

  const STYLES = `
    :host { display: block; font-family: 'Zona Pro', system-ui, -apple-system, sans-serif;
            color: #fafafa; background: hsl(240 15% 4%); }
    *, *::before, *::after { box-sizing: border-box; }
    .wrap { max-width: 1500px; margin: 0 auto; padding: 5rem 1.25rem; position: relative; }
    .glow { position: absolute; inset: 0; pointer-events: none; opacity: .3;
            background: radial-gradient(ellipse 80% 50% at 50% 30%, hsl(14 100% 58% / .2) 0%, transparent 60%); }
    .header { text-align: center; margin-bottom: 4.5rem; position: relative; z-index: 1; }
    .badge { display: inline-flex; align-items: center; gap: .5rem; color: hsl(14 100% 58%);
             font-size: .875rem; text-transform: uppercase; letter-spacing: .1em; font-weight: 500;
             margin-bottom: 1.25rem; }
    h2 { font-size: clamp(3rem, 5.6vw, 5.5rem); font-weight: 700; line-height: 1.02;
         letter-spacing: -0.035em; margin: 0 0 2rem; text-wrap: balance; }
    .gradient { background: linear-gradient(90deg, hsl(14 100% 58%), hsl(28 100% 55%), hsl(14 100% 65%));
                -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }
    .sub { color: hsl(240 5% 60%); max-width: 48rem; margin: 0 auto; font-size: clamp(1.125rem, 1.6vw, 1.4rem); }
    .grid { display: grid; grid-template-columns: 1fr; gap: 2.5rem; position: relative; z-index: 1; }
    @media (min-width: 768px) { .grid { grid-template-columns: 1fr 1fr; } }
    .panel { background: hsl(240 12% 8% / .5); border: 1px solid hsl(240 10% 16%);
             border-radius: 1.125rem; padding: clamp(2rem, 3vw, 3rem); backdrop-filter: blur(8px); }
    .panel-title { display: flex; align-items: center; gap: .625rem; margin-bottom: 2.25rem;
                   font-size: 1.4rem; font-weight: 700; }
    .icon { width: 24px; height: 24px; color: hsl(14 100% 58%); flex-shrink: 0; }
    .field { margin-bottom: 2.75rem; }
    .field-row { display: flex; justify-content: space-between; align-items: center; gap: 1rem; margin-bottom: 1rem; }
    label { font-size: 1.075rem; color: hsl(240 5% 60%); }
    .value { color: hsl(14 100% 58%); font-size: 1.2rem; font-weight: 600; text-align: right; }
    input[type=range] { -webkit-appearance: none; appearance: none; display: block; width: 100%; height: 8px;
                        margin: 0; padding: 0; border: 0; border-radius: 999px; outline: none;
                        background: linear-gradient(to right,
                          hsl(14 100% 58%) 0 var(--range-progress, 0%),
                          hsl(240 10% 14%) var(--range-progress, 0%) 100%);
                        cursor: pointer; touch-action: pan-y; pointer-events: auto; }
    input[type=range]::-webkit-slider-thumb { -webkit-appearance: none; appearance: none;
      width: 28px; height: 28px; border-radius: 50%; background: hsl(240 12% 8%);
      cursor: grab; border: 3px solid hsl(14 100% 58%);
      box-shadow: 0 0 0 2px hsl(240 15% 4%), 0 0 14px hsl(14 100% 58% / .45); }
    input[type=range]::-moz-range-thumb { width: 22px; height: 22px; border-radius: 50%;
      background: hsl(240 12% 8%); cursor: grab; border: 3px solid hsl(14 100% 58%);
      box-shadow: 0 0 0 2px hsl(240 15% 4%), 0 0 14px hsl(14 100% 58% / .45); }
    input[type=range]:active::-webkit-slider-thumb { cursor: grabbing; }
    input[type=range]:active::-moz-range-thumb { cursor: grabbing; }
    .range-scale { display: flex; justify-content: space-between; font-size: .9rem;
                   color: hsl(240 5% 50%); margin-top: .65rem; }
    input[type=number], select { width: 100%; background: hsl(240 15% 4% / .5);
      border: 1px solid hsl(240 10% 16%); color: #fafafa; padding: .9rem 1rem;
      min-height: 54px; border-radius: .5rem; font-family: inherit; font-size: 1.1rem; }
    input:focus, select:focus { outline: none; border-color: hsl(14 100% 58%);
      box-shadow: 0 0 0 3px hsl(14 100% 58% / .2); }
    .result { background: hsl(240 10% 12% / .3); border: 1px solid hsl(240 10% 16% / .5);
              border-radius: .875rem; padding: 1.5rem; margin-bottom: 1.5rem; }
    .result-label { font-size: 1.075rem; color: hsl(240 5% 60%); margin: 0 0 .4rem; }
    .result-value { font-size: 2rem; font-weight: 700; line-height: 1.15; margin: 0; }
    .result-tiny { font-size: .9rem; color: hsl(240 5% 50%); margin: .4rem 0 0; }
    .result-line { font-size: 1.05rem; margin: .4rem 0; }
    .result-line .value { font-weight: 600; }
    .highlight { background: hsl(14 100% 58% / .1); border: 1px solid hsl(14 100% 58% / .3);
                 box-shadow: inset 0 0 0 1px hsl(14 100% 58% / .3), 0 0 20px -5px hsl(14 100% 58% / .4); }
    .package { background: hsl(240 12% 8%); border: 1px solid hsl(14 100% 58% / .5);
               border-radius: .875rem; padding: 1.5rem; text-align: center; }
    .package-title { font-size: 1.35rem; font-weight: 700; margin: .65rem 0 .35rem; }
    .package-count { font-size: 1rem; color: hsl(240 5% 60%); margin: 0 0 .35rem; }
    .package-price { font-size: 1.1rem; color: hsl(14 100% 58%); font-weight: 600; margin: 0 0 1rem; }
    .btn { display: inline-flex; align-items: center; justify-content: center; gap: .5rem;
      width: 100%; min-height: 54px; padding: .85rem 1.5rem; border-radius: .5rem; font-family: inherit;
      font-weight: 600; font-size: 1.1rem; border: none; cursor: pointer; text-decoration: none;
      background: hsl(14 100% 58%); color: hsl(240 15% 4%);
      transition: box-shadow .2s ease, transform .15s ease; }
    .btn:hover { box-shadow: 0 0 24px -4px hsl(14 100% 58% / .6); transform: translateY(-1px); }
    @media (max-width: 767px) {
      .wrap { padding: 3.5rem 1rem; }
      .header { margin-bottom: 3rem; }
      h2 { font-size: clamp(2.6rem, 13vw, 4rem); }
      .panel { padding: 1.5rem; }
      .field-row { align-items: flex-start; }
    }
  `;

  class KomfidCalculator extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.state = {
        guests: parseInt(this.getAttribute('default-guests') || '400', 10),
        genderRatio: 50,
        currency: (this.getAttribute('currency') || 'DKK').toUpperCase(),
        entranceFee: 60,
      };
      this.config = {
        lang: (this.getAttribute('lang') || 'en').toLowerCase(),
        packageUrl: this.getAttribute('package-url') || 'https://komfid.com/products/komfid-lids-pro',
        packagePrice: parseFloat(this.getAttribute('package-price') || '1000'),
        packageSize: parseInt(this.getAttribute('package-size') || '480', 10),
        lidCost: parseFloat(this.getAttribute('lid-cost') || '2.76'),
      };
      if (!I18N[this.config.lang]) this.config.lang = 'en';
      if (!CURRENCY[this.state.currency]) this.state.currency = 'DKK';
    }

    connectedCallback() { this.render(); }

    calc() {
      const { guests, genderRatio, currency, entranceFee } = this.state;
      const { packagePrice, packageSize, lidCost } = this.config;
      const female = (100 - genderRatio) / 100;
      const male = genderRatio / 100;
      const lidsMin = Math.round(guests * female * 0.6) + Math.round(guests * male * 0.15);
      const lidsMax = Math.round(guests * female * 0.8) + Math.round(guests * male * 0.25);
      const rate = CURRENCY[currency].rate;
      const costMin = lidsMin * lidCost * rate;
      const costMax = lidsMax * lidCost * rate;
      const revLow  = guests * 0.02 * entranceFee;
      const revHigh = guests * 0.05 * entranceFee;
      const avgCost = (costMin + costMax) / 2;
      const avgLids = (lidsMin + lidsMax) / 2;
      const packages = Math.max(1, Math.ceil(avgLids / packageSize));
      const totalPkg = packages * packagePrice * rate;
      return { lidsMin, lidsMax, costMin, costMax, revLow, revHigh,
        netLow: revLow - avgCost, netHigh: revHigh - avgCost,
        packages, totalPkg };
    }

    fmt(n) {
      return Math.round(n).toLocaleString(CURRENCY[this.state.currency].locale);
    }

    render() {
      const t = I18N[this.config.lang];
      const s = this.state;
      const r = this.calc();
      const sym = CURRENCY[s.currency].symbol;
      this.shadowRoot.innerHTML = `
        <style>${STYLES}</style>
        <section class="wrap">
          <div class="glow"></div>
          <div class="header">
            <div class="badge">◆ ${t.label}</div>
            <h2>${t.headline} <span class="gradient">${t.headlineAccent}</span></h2>
            <p class="sub">${t.subheadline}</p>
          </div>
          <div class="grid">
            <div class="panel">
              <div class="panel-title">${t.venueDetails}</div>

              <div class="field">
                <div class="field-row"><label>${t.numberOfGuests}</label><span class="value" data-out="guests">${s.guests}</span></div>
                <input type="range" min="50" max="2500" step="10" value="${s.guests}" data-in="guests">
                <div class="range-scale"><span>50</span><span>2500</span></div>
              </div>

              <div class="field">
                <div class="field-row"><label>${t.genderDistribution}</label>
                  <span class="value" data-out="gender">${s.genderRatio}% ${t.male} / ${100 - s.genderRatio}% ${t.female}</span>
                </div>
                <input type="range" min="0" max="100" step="5" value="${s.genderRatio}" data-in="genderRatio">
                <div class="range-scale"><span>0% ${t.male}</span><span>100% ${t.male}</span></div>
              </div>

              <div class="field">
                <label style="display:block;margin-bottom:.5rem;">${t.currency}</label>
                <select data-in="currency">
                  ${Object.entries(CURRENCY).map(([k, v]) =>
                    `<option value="${k}" ${k === s.currency ? 'selected' : ''}>${v.label}</option>`).join('')}
                </select>
              </div>

              <div class="field">
                <label data-out="entranceLabel" style="display:block;margin-bottom:.65rem;">${t.entranceFee} (${sym})</label>
                <input type="number" min="0" value="${s.entranceFee}" data-in="entranceFee">
              </div>
            </div>

            <div class="panel">
              <div class="panel-title">${t.yourResults}</div>

              <div class="result">
                <p class="result-label">${t.estimatedLids}</p>
                <p class="result-value" data-out="lids">${r.lidsMin} - ${r.lidsMax}</p>
                <p class="result-tiny">${t.perNight}</p>
              </div>

              <div class="result">
                <p class="result-label">${t.costPerNight}</p>
                <p class="result-value" data-out="cost">${this.fmt(r.costMin)} - ${this.fmt(r.costMax)} ${sym}</p>
              </div>

              <div class="result">
                <p class="result-label">${t.revenueIncrease}</p>
                <p class="result-line">${t.with2Percent}: <span class="value" data-out="revLow">${this.fmt(r.revLow)} ${sym}</span></p>
                <p class="result-line">${t.with5Percent}: <span class="value" data-out="revHigh">${this.fmt(r.revHigh)} ${sym}</span></p>
                <p class="result-tiny">${t.plusBarRevenue}</p>
              </div>

              <div class="result highlight">
                <p class="result-label">${t.netBenefit}</p>
                <p class="result-line">${t.conservative}: <span class="value" data-out="netLow">${this.fmt(r.netLow)} ${sym}</span></p>
                <p class="result-line">${t.optimistic}: <span class="value" data-out="netHigh">${this.fmt(r.netHigh)} ${sym}</span></p>
              </div>

              <div class="package">
                <p class="result-label">${t.recommendedPackage}</p>
                <p class="package-title" data-out="packageTitle">${r.packages}x ${t.packageName}</p>
                <p class="package-count" data-out="packageCount">${r.packages * this.config.packageSize} ${t.lids}</p>
                <p class="package-price" data-out="packagePrice">${this.fmt(r.totalPkg)} ${sym}</p>
                <a class="btn" href="${this.config.packageUrl}" target="_blank" rel="noopener">${t.orderNow}</a>
                <p class="result-tiny" style="margin-top:.5rem;">${t.exclVat}</p>
              </div>
            </div>
          </div>
        </section>
      `;
      this.bind();
    }

    bind() {
      this.shadowRoot.querySelectorAll('[data-in]').forEach(el => {
        el.addEventListener('input', (e) => {
          const key = el.dataset.in;
          let val = e.target.value;
          if (key !== 'currency') val = Number(val) || 0;
          this.state[key] = val;
          this.update();
        });
      });
      this.update();
    }

    update() {
      const t = I18N[this.config.lang];
      const s = this.state;
      const r = this.calc();
      const sym = CURRENCY[s.currency].symbol;
      const setText = (name, value) => {
        const el = this.shadowRoot.querySelector(`[data-out="${name}"]`);
        if (el) el.textContent = value;
      };

      setText('guests', s.guests);
      setText('gender', `${s.genderRatio}% ${t.male} / ${100 - s.genderRatio}% ${t.female}`);
      setText('entranceLabel', `${t.entranceFee} (${sym})`);
      setText('lids', `${r.lidsMin} - ${r.lidsMax}`);
      setText('cost', `${this.fmt(r.costMin)} - ${this.fmt(r.costMax)} ${sym}`);
      setText('revLow', `${this.fmt(r.revLow)} ${sym}`);
      setText('revHigh', `${this.fmt(r.revHigh)} ${sym}`);
      setText('netLow', `${this.fmt(r.netLow)} ${sym}`);
      setText('netHigh', `${this.fmt(r.netHigh)} ${sym}`);
      setText('packageTitle', `${r.packages}x ${t.packageName}`);
      setText('packageCount', `${r.packages * this.config.packageSize} ${t.lids}`);
      setText('packagePrice', `${this.fmt(r.totalPkg)} ${sym}`);

      this.shadowRoot.querySelectorAll('input[type="range"]').forEach(input => {
        const min = Number(input.min);
        const max = Number(input.max);
        const value = Number(input.value);
        const progress = ((value - min) / (max - min)) * 100;
        input.style.setProperty('--range-progress', `${progress}%`);
      });
    }
  }

  customElements.define('komfid-calculator', KomfidCalculator);
})();
